// import React, { createContext, useRef, useState, useEffect } from 'react';
// import { useLocation } from 'react-router-dom';
// import soundsConfig from '/data/soundsConfig.json';
// import useTabVisibility from './IsTabActive';
// import gsap from 'gsap';

// export const AudioContext = createContext();

// export const AudioProvider = ({ children }) => {
//     const transiRef = useRef(null); 
//     const soundRefs = useRef({
//         muffledSound: null,
//         clearSound: null,
//         manifestants: null,
//         interview: null,
//     });

//   const [isPlaying, setIsPlaying] = useState(true);
//   const [userInteraction, setUserInteraction] = useState(false);
//   const location = useLocation();

//   const loadingPromise = useRef(
//     new Promise((resolve) => {
//       const checkAudioLoaded = () => {
//         const audioElements = [
//           ...Object.values(soundRefs.current),
//           transiRef.current,
//         ];
//         let loadedCount = 0;

//         const handleCanPlayThrough = () => {
//           loadedCount += 1;
//           if (loadedCount === audioElements.length) {
//             resolve();
//           }
//         };

//         audioElements.forEach((audio) => {
//           if (audio) {
//             audio.addEventListener('canplaythrough', handleCanPlayThrough, { once: true });
//           }
//         });

//         return () => {
//           audioElements.forEach((audio) => {
//             if (audio) {
//               audio.removeEventListener('canplaythrough', handleCanPlayThrough);
//             }
//           });
//         };
//       };

//       checkAudioLoaded();
//     })
//   );

//   if (!loadingPromise.current) {
//     throw loadingPromise.current;
//   }

//   const getVolumeConfig = () => soundsConfig[location.pathname] || soundsConfig.default;

//   const controlSound = (soundRef, volume, loop = true) => {
//     if (soundRef) {
//       gsap.to(soundRef, {
//         volume: volume,
//         duration: 1.5,
//         onStart: () => {
//           if (volume > 0) {
//             soundRef.play().catch(() => {});
//             soundRef.loop = loop;
//           }
//         },
//         onComplete: () => {
//           if (volume === 0) {
//             soundRef.pause();
//           }
//         },
//       });
//     }
//   };

//   const applyVolumeConfig = () => {
//     if (!userInteraction || !isPlaying) {
//       return;
//     }
//     const volumeConfig = getVolumeConfig();
//     Object.entries(soundRefs.current).forEach(([key, soundRef]) => {
//       const targetVolume = volumeConfig[key] || 0;
//       controlSound(soundRef, targetVolume, key);
//     });
//   };

//   const stopSounds = () => {
//     Object.values(soundRefs.current).forEach((soundRef) => {
//         if (soundRef) {
//           gsap.to(soundRef, {
//             volume: 0,
//             duration: 0.5,
//           });
//         }
//       });
//       setIsPlaying(false);
// };

// const playTransi = () => {
//     if (isPlaying && userInteraction) {
//       const transiSoundRef = transiRef.current;
//       if (transiSoundRef) {
//         gsap.to(transiSoundRef, {
//           volume: 0.8,
//           duration: 0.4,
//         });
//         transiSoundRef.currentTime = 0;
//         transiSoundRef.play().catch((error) => {
//           console.error('Erreur de lecture du son transi:', error);
//         });
//       }
//     }
//   };

//   useEffect(() => {
//     const handleUserInteraction = () => setUserInteraction(true);
//     document.addEventListener('click', handleUserInteraction);
//     return () => document.removeEventListener('click', handleUserInteraction);
//   }, []);

//   useEffect(() => {
//     applyVolumeConfig();
//   }, [location.pathname, userInteraction, isPlaying]);

//   const playSounds = () => {
//     setIsPlaying(true);
//   };

//   useEffect(() => {
//     playTransi();
//   }, [location.pathname]);

//   return (
//     <AudioContext.Provider
//       value={{
//         playSounds,
//         stopSounds,
//         isPlaying,
//       }}
//     >
//       {children}

//       <audio ref={(el) => (soundRefs.current.muffledSound = el)} src="/sounds/muffled_soundtrack.mp3" />
//       <audio ref={(el) => (soundRefs.current.clearSound = el)} src="/sounds/clear_soundtrack.mp3" />
//       <audio ref={(el) => (soundRefs.current.manifestants = el)} src="/sounds/manifestants.mp3" />
//       <audio ref={(el) => (soundRefs.current.interview = el)} src="/sounds/interview.mp3" />
//       <audio ref={transiRef} src="/sounds/transi.mp3" />
//     </AudioContext.Provider>
//   );
// };








import React, { createContext, useRef, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import soundsConfig from '/data/soundsConfig.json';
import gsap from 'gsap';

export const AudioContext = createContext();

export const AudioProvider = ({ children }) => {
    const transiRef = useRef(null); 
    const soundRefs = useRef({
        muffledSound: null,
        clearSound: null,
        manifestants: null,
        interview: null,
    });

    const [isPlaying, setIsPlaying] = useState(false);
    const [audioInitialized, setAudioInitialized] = useState(false);
    const [firstInteraction, setFirstInteraction] = useState(false);
    const location = useLocation();

    const getVolumeConfig = () => soundsConfig[location.pathname] || soundsConfig.default;

    const initializeAudio = async () => {
        try {
            const audioElements = [
                ...Object.values(soundRefs.current),
                transiRef.current,
            ].filter(Boolean);

            for (let audio of audioElements) {
                try {
                    await audio.play();
                    audio.pause();
                } catch (error) {
                    console.warn('Initialisation audio impossible:', error);
                }
            }

            setAudioInitialized(true);
        } catch (error) {
            console.error('Erreur d\'initialisation audio:', error);
        }
    };

    const controlSound = (soundRef, volume, key = '') => {
        if (!soundRef || !audioInitialized) return;

        gsap.to(soundRef, {
            volume: volume,
            duration: 1.5,
            onStart: () => {
                if (volume > 0) {
                    soundRef.play().catch((error) => {
                        console.warn(`Impossible de jouer ${key}:`, error);
                    });
                    soundRef.loop = key !== 'transi';
                }
            },
            onComplete: () => {
                if (volume === 0) {
                    soundRef.pause();
                }
            },
        });
    };

    const applyVolumeConfig = () => {
        if (!audioInitialized || !isPlaying) return;

        const volumeConfig = getVolumeConfig();
        Object.entries(soundRefs.current).forEach(([key, soundRef]) => {
            const targetVolume = volumeConfig[key] || 0;
            controlSound(soundRef, targetVolume, key);
        });
    };

    const stopSounds = () => {
        Object.values(soundRefs.current).forEach((soundRef) => {
            if (soundRef) {
                gsap.to(soundRef, {
                    volume: 0,
                    duration: 0.5,
                });
            }
        });
        setIsPlaying(false);
    };

    const playTransi = () => {
        if (isPlaying && audioInitialized) {
            const transiSoundRef = transiRef.current;
            if (transiSoundRef) {
                gsap.to(transiSoundRef, {
                    volume: 0.8,
                    duration: 0.4,
                });
                transiSoundRef.currentTime = 0;
                transiSoundRef.play().catch((error) => {
                    console.warn('Erreur de lecture du son transi:', error);
                });
            }
        }
    };

    useEffect(() => {
        const handleFirstInteraction = () => {
            if (!firstInteraction) {
                initializeAudio();
                setFirstInteraction(true);
                setIsPlaying(true);
                document.removeEventListener('click', handleFirstInteraction);
            }
        };
        document.addEventListener('click', handleFirstInteraction);
        return () => document.removeEventListener('click', handleFirstInteraction);
    }, [firstInteraction]);

    useEffect(() => {
        applyVolumeConfig();
    }, [location.pathname, audioInitialized, isPlaying]);

    useEffect(() => {
        playTransi();
    }, [location.pathname]);

    return (
        <AudioContext.Provider
            value={{
                playSounds: () => setIsPlaying(true),
                stopSounds,
                isPlaying,
            }}
        >
            {children}

            <audio ref={(el) => (soundRefs.current.muffledSound = el)} preload="metadata" src="/sounds/muffled_soundtrack.mp3" />
            <audio ref={(el) => (soundRefs.current.clearSound = el)} preload="metadata" src="/sounds/clear_soundtrack.mp3" />
            <audio ref={(el) => (soundRefs.current.manifestants = el)} preload="metadata" src="/sounds/manifestants.mp3" />
            <audio ref={(el) => (soundRefs.current.interview = el)} preload="metadata" src="/sounds/interview.mp3" />
            <audio ref={transiRef} preload="metadata" src="/sounds/transi.mp3" />
        </AudioContext.Provider>
    );
};